module.exports = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/sounds/btn_click",
            "res/sounds/orel_click",
            "res/sounds/reshka_click",
            "res/sounds/play_click",
            "res/sounds/settings_click",
            "res/sounds/lose",
            "res/sounds/win",
            "res/sounds/rotate",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            //
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 125
// module chunks = 0